// Utility for exporting DOM nodes as PNG using html2canvas and dom-to-image-more

export async function exportAsPngHtml2Canvas(
  node: HTMLElement,
  filename: string,
) {
  const html2canvasModule = await import('html2canvas');
  const html2canvas = html2canvasModule.default;

  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }
  await new Promise(res => setTimeout(res, 200));

  // Force reflow
  node.offsetHeight;

  const canvas = await html2canvas(node, {
    scale: 3, // Higher quality
    useCORS: true,
    backgroundColor: null,
    allowTaint: true,
    onclone: clonedDoc => {
      // Set font-family on all elements in the cloned node
      const clonedNode = clonedDoc.body.firstChild;
      if (clonedNode && clonedNode instanceof HTMLElement) {
        Array.from(clonedNode.querySelectorAll('*')).forEach(e => {
          let existingStyle = e.getAttribute('style') || '';
          e.setAttribute(
            'style',
            existingStyle + '; font-family: NeoSans, sans-serif !important',
          );
        });
      }
    },
  });

  const image = canvas.toDataURL('image/png');
  const link = document.createElement('a');
  link.download = filename;
  link.href = image;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
